import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in Nigeria</p>
        <h1>Catholic Nigeria</h1>
        <p className="lede">
          Nigeria is home to roughly 35 million Catholics -- about 15.8% of the population -- making it Africa's second-largest Catholic nation and one of the most active parish cultures anywhere in the world.
        </p>
        <div className="cta-row">
          <a href="#growth">
            Church Growth
          </a>
          <a href="#parishes" className="secondary">
            Parish Life
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Remarkable Growth</h2>
          <p>
            Africa's Catholic population rose from roughly 281 million in 2023 to over 288 million in 2024, with Nigeria a major driver of that growth, now Africa's second-largest Catholic nation.
          </p>
        </article>
        <article>
          <h2>The Highest Mass Attendance Anywhere</h2>
          <p>
            Nigeria reports a weekly Mass attendance rate around 94% -- widely cited as the highest of any country in the world -- reflecting an unusually vibrant parish culture.
          </p>
        </article>
        <article>
          <h2>A Vast Institutional Church</h2>
          <p>
            The Nigerian Church counts 82 bishops, 10,309 priests, 4,944 parishes, and 12,302 mission stations, one of the largest clergy and parish networks on the continent.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Ecclesiastical Provinces & Leadership</h2>
        <p className="section-sub">Nigeria has 9 Latin-rite ecclesiastical provinces and 44 suffragan dioceses.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Kaduna</h3>
            <p>Archbishop Matthew Man-Oso Ndagoso, CBCN President (elected Feb 2026)</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Lagos</h3>
            <p>Archbishop Alfred Adewale Martins, CBCN Vice President</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Abeokuta</h3>
            <p>Bishop Peter Kayode Odetoyinbo, CBCN Secretary</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Owerri</h3>
            <p>Archbishop Lucius Iwejuru Ugorji, outgoing CBCN President</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">February 2026</p>
            <h3>New national bishops' conference leadership elected</h3>
            <p>Archbishop Matthew Man-Oso Ndagoso of Kaduna was elected President of the Catholic Bishops' Conference of Nigeria at the CBCN's first 2026 Plenary Assembly.</p>
            <p className="news-source">Source: ACI Africa</p>
          </article>
          <article className="news-item">
            <p className="news-date">January 14, 2026</p>
            <h3>New cathedral dedicated in Anambra State</h3>
            <p>The Cathedral of Our Lady of Assumption in Nnewi was formally dedicated, adding a significant new church building to the Nigerian Catholic landscape.</p>
            <p className="news-source">Source: Wikipedia</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
